var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_44",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 14.4167L13.9167 13.2501L10.8334 10.1667V6.33341H9.16672V10.8334L12.7501 14.4167ZM10.0001 18.8334C8.84728 18.8334 7.76395 18.6147 6.75006 18.1772C5.73617 17.7397 4.85422 17.1459 4.10422 16.3959C3.35422 15.6459 2.76048 14.764 2.32298 13.7501C1.88548 12.7362 1.66673 11.6529 1.66673 10.5001C1.66673 9.3473 1.88548 8.26397 2.32298 7.25008C2.76048 6.23619 3.35422 5.35425 4.10422 4.60425C4.85422 3.85425 5.73617 3.2605 6.75006 2.823C7.76395 2.3855 8.84728 2.16675 10.0001 2.16675C11.1528 2.16675 12.2362 2.3855 13.2501 2.823C14.2639 3.2605 15.1459 3.85425 15.8959 4.60425C16.6459 5.35425 17.2396 6.23619 17.6771 7.25008C18.1146 8.26397 18.3334 9.3473 18.3334 10.5001C18.3334 11.6529 18.1146 12.7362 17.6771 13.7501C17.2396 14.764 16.6459 15.6459 15.8959 16.3959C15.1459 17.1459 14.2639 17.7397 13.2501 18.1772C12.2362 18.6147 11.1528 18.8334 10.0001 18.8334ZM10.0001 17.1667C11.8473 17.1667 13.4202 16.5174 14.7188 15.2188C16.0174 13.9202 16.6667 12.3473 16.6667 10.5001C16.6667 8.65286 16.0174 7.07994 14.7188 5.78133C13.4202 4.48272 11.8473 3.83341 10.0001 3.83341C8.15284 3.83341 6.57992 4.48272 5.28131 5.78133C3.9827 7.07994 3.33339 8.65286 3.33339 10.5001C3.33339 12.3473 3.9827 13.9202 5.28131 15.2188C6.57992 16.5174 8.15284 17.1667 10.0001 17.1667Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.ca9d41505f5ff09f78efb0c36198b849.svg";
export { ForwardRef as ReactComponent };